module.exports = __webpack_public_path__ + "static/media/forest_audio.a95d10ed.mp4";